{
  "title": "Facial Recognition",
  "description": "Internal Campminder tools for facial recognition.",
  "tabs": {
    "faceOff": "Face Off"
  }
}
